import { render, staticRenderFns } from "./editar.vue?vue&type=template&id=b86237b4&scoped=true"
import script from "./editar.vue?vue&type=script&lang=js"
export * from "./editar.vue?vue&type=script&lang=js"
import style0 from "./editar.vue?vue&type=style&index=0&id=b86237b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86237b4",
  null
  
)

export default component.exports